// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import arrowRightIcon from "@/assets/icons/arrow-right.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArrowRightIconProps = Omit<IconProps, "name">;

export function ArrowRightIcon(props: ArrowRightIconProps): React.ReactNode {
  return <Icon name={arrowRightIcon} {...props} />;
}
